<script setup lang="ts">
import { useForm } from "@inertiajs/vue3"
import AuthShell from "./components/AuthShell.vue"

const props = defineProps<{
  reset_password_token: string
  errors?: Record<string, string[]>
}>()

const form = useForm({
  reset_password_token: props.reset_password_token,
  password: "",
  password_confirmation: "",
})

const fieldError = (field: string) => props.errors?.[field]?.[0]
</script>

<template>
  <AuthShell title="Definir nova senha" subtitle="Escolha uma senha forte para sua conta.">
    <form class="space-y-4" @submit.prevent="form.put('/users/password')">
      <input v-model="form.reset_password_token" type="hidden" />

      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="password">Nova senha</label>
        <input id="password" v-model="form.password" type="password" required class="w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm outline-none transition focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200" />
        <p v-if="fieldError('password')" class="mt-1 text-sm text-rose-600">{{ fieldError('password') }}</p>
      </div>

      <div>
        <label class="mb-1 block text-sm font-medium text-slate-700" for="password_confirmation">Confirmar nova senha</label>
        <input id="password_confirmation" v-model="form.password_confirmation" type="password" required class="w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm outline-none transition focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200" />
      </div>

      <button type="submit" :disabled="form.processing" class="w-full rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-indigo-700 disabled:cursor-not-allowed disabled:opacity-60">
        Atualizar senha
      </button>
    </form>
  </AuthShell>
</template>
